import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PageLoader } from '../components/PageLoader';
import {
  AuthCallback,
  LoginPage,
  RegistrationPage,
  ForgotPasswordPage,
  EmailVerificationPage,
  GoogleOAuthSuccess,
  PendingVerification,
  OnboardingPage,
} from './lazyPages';
import { dashboardRouteElements } from './dashboardRoutes';
import {
  BookingsRedirect,
  NetworkAnalyticsRedirect,
  NetworkCalendarRedirect,
  NetworkRedirect,
  ProfileRedirect,
  QueryPreservingRedirect,
} from './redirects';
import { RouteErrorBoundary } from '../../shared/components/common/RouteErrorBoundary';

function lazyRoute(element: React.ReactNode) {
  return (
    <RouteErrorBoundary>
      <Suspense fallback={<PageLoader />}>{element}</Suspense>
    </RouteErrorBoundary>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      {/* Auth */}
      <Route path="/login" element={lazyRoute(<LoginPage />)} />
      <Route path="/signin" element={<QueryPreservingRedirect to="/login" />} />
      <Route path="/signup" element={lazyRoute(<RegistrationPage />)} />
      <Route path="/forgot-password" element={lazyRoute(<ForgotPasswordPage />)} />
      <Route path="/verify-email" element={lazyRoute(<EmailVerificationPage />)} />
      <Route path="/oauth/google/success" element={lazyRoute(<GoogleOAuthSuccess />)} />
      <Route path="/auth-callback" element={lazyRoute(<AuthCallback />)} />

      {/* Onboarding (post-login, before dashboard) */}
      <Route path="/onboarding" element={lazyRoute(<OnboardingPage />)} />
      <Route path="/pending-verification" element={lazyRoute(<PendingVerification />)} />

      {dashboardRouteElements}

      <Route path="/resume-review" element={<QueryPreservingRedirect to="/jobseeker-dashboard/resume-review" />} />
      <Route path="/culture-call" element={<QueryPreservingRedirect to="/jobseeker-dashboard/mock-interview" />} />
      <Route path="/mock-interview" element={<QueryPreservingRedirect to="/jobseeker-dashboard/mock-interview" />} />
      <Route path="/referral-session" element={<QueryPreservingRedirect to="/jobseeker-dashboard/referral-session" />} />

      <Route path="/bookings" element={<BookingsRedirect />} />
      <Route path="/my-sessions" element={<BookingsRedirect />} />
      <Route path="/rate-review" element={<BookingsRedirect />} />
      <Route path="/marketplace" element={<QueryPreservingRedirect to="/jobseeker-dashboard/referral-session" />} />
      <Route path="/profile" element={<ProfileRedirect />} />

      <Route path="/services" element={<QueryPreservingRedirect to="/referral-dashboard/services" />} />
      <Route path="/network-page" element={<NetworkRedirect />} />
      <Route path="/network" element={<NetworkRedirect />} />
      <Route path="/network-page/calendar" element={<NetworkCalendarRedirect />} />
      <Route path="/network/analytics" element={<NetworkAnalyticsRedirect />} />
      <Route path="/analytics/withdrawal" element={<QueryPreservingRedirect to="/referral-dashboard/analytics/withdrawal" />} />

      <Route path="/interview-prep" element={<QueryPreservingRedirect to="/jobseeker-dashboard/mock-interview" />} />
      <Route path="/service" element={<QueryPreservingRedirect to="/referral-dashboard/services" />} />

      <Route path="/payouts" element={<ProfileRedirect />} />
      <Route path="/network/payout" element={<ProfileRedirect />} />
      <Route path="/wallet-recharge" element={<ProfileRedirect />} />

      <Route path="/job-openings" element={<QueryPreservingRedirect to="/jobseeker-dashboard/jobopenings" />} />
      <Route path="/network/job-opening" element={<QueryPreservingRedirect to="/jobseeker-dashboard/jobopenings" />} />

      <Route path="/" element={<Navigate to="/signup" replace />} />
      <Route path="*" element={<Navigate to="/signup" replace />} />
    </Routes>
  );
}
